import axios from "axios";
import qs from "qs";
import * as actionType from "../../../constant/actionType";

export const GetWorkersForClientInductionReport = (apiData) => async () => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/client/GetWorkersForClientInductionReport`,
      params: apiData,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
